import type { Rotina } from "~/types/pagesMenu";

export const nomesRotinasNaoConformidade = {
	NAO_CONFORMIDADE_EXPRESSA: "Não Conformidade Expressa",
} as const;

export type RotinasNaoConformidade =
	typeof nomesRotinasNaoConformidade[keyof typeof nomesRotinasNaoConformidade];

/**
 * Rotinas da categoria "Gestão de Não Conformidade" — o "B37" do
 * `SIST_MAINFORM`.
 *
 * ATENÇÃO ao campo `nome`: ele é comparado contra `ACEUSU_ID_MENU_PF` da
 * `CORE_ACESSO_USUARIO`, e o item some do menu em silêncio quando não casa.
 * `mni_B371NaoConformidadeExpressa` foi conferido na base da dev1 (AGALDINO):
 * existe, com 13 usuários. Não precisou de liberação à parte.
 *
 * O `label` não repete o código porque `collectorOptions.vue` já desenha o
 * "B371" em elemento próprio, a partir de `tela`. Repetir aqui sairia como
 * "B371 B371 - Não Conformidade Expressa" no botão.
 */
const rotinasNaoConformidade: Rotina[] = [
	{
		categoria: "Gestão de Não Conformidade",
		label: nomesRotinasNaoConformidade.NAO_CONFORMIDADE_EXPRESSA,
		nome: "mni_B371NaoConformidadeExpressa",
		rotina: "naoConformidade/expressa",
		tela: "B371",
		disponivel: true,
	},
];

export { rotinasNaoConformidade };
